export default __webpack_public_path__ + "static/media/menu.2f5ea949.png";